import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";

import style from "./list.module.sass";
import { Http } from "../../../../helpers/axois";
import { useToast } from "../../../../helpers/commonFunction";
const dmnItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
};

interface Props {
    onSubmit: (submit: () => void) => void;
    appId?: any;
    getSolo?: () => void;
    getSoloFlows?: any;
    getDmn?: () => void;
    soloModal?: boolean;
    addFroms?: (data: any) => void;
    editInitialData?: any;
    editable?: boolean;
    currentBranch?: any;
    selectedJourney?: any;
    appVersion?: { currentVersion: boolean, versionId: string };
    editSoloData?: any;
    editType?: string;
    setvisible: any;
}

const Dmn = (props: Props) => {
    const { SuccessToast, ErrorToast } = useToast();
    let { editInitialData } = props;
    const [formName, setFormName] = useState("");
    const [displayError, setDisplayError]: any = useState({});
    const [description, setDescription] = useState("")

    useEffect(() => {
        props.onSubmit && props.onSubmit(onSubmit);
    })

    const onSubmit = () => {
        let { editable, editInitialData } = props;
        if ((editable && formName)) {
            editForm(editInitialData.dmnId)
        } else if (editable && !formName && !editInitialData?.dmnName) {
            setDisplayError({ editDisplayErr: "required" })
        }
        if ((!editable && formName)) {
            createForm();
        } else if (!editable && !formName) {
            setDisplayError({ flowNameFieldDisplayErr: "required" })
            // setState({ selectedFlowDisplayErr: "required" })
        }
    };

    const createForm = () => {
        const { getDmn } = props
        const currentBranchId = props.currentBranch && props.currentBranch[props.appId] && props.currentBranch[props.appId].branchId
        const data = {
            name: formName,
            appId: props.appId,
            description: description,
            branchId: currentBranchId
        }
        Http.post('/dmn', data).subscribe((formRes) => {
            getDmn && getDmn()
            SuccessToast("Dmn saved Successfully", true)
            props.setvisible(false)
        }, (err) => {
            ErrorToast((err && err.message) ? err.message : 'Dmn save failed', true)
            props.setvisible(false)
        })
    }

    const editForm = (dmnId?: string) => {
        const data = {
            name: formName,
            description: description,
            appId: props.appId
        }
        Http.put(`/dmn/${dmnId}?appId=${props.appId}`, data).subscribe((formRes) => {
            SuccessToast('Dmn updated successfully', true)
            props.getDmn && props.getDmn();
            props.setvisible(false)
        }, (err) => {
            ErrorToast((err && err.message) ? err.message : 'Dmn updation failed', true)
            props.setvisible(false)
        })
    }

    return (
        <div>
            {<Form {...dmnItemLayout} className={style.app + ' override-content'}>
                <Form.Item
                    validateStatus={(displayError?.flowNameFieldDisplayErr && "error") || (displayError?.editDisplayErr && "error")}
                    help={displayError.flowNameFieldDisplayErr || displayError.editDisplayErr}
                    label={<span className={style.labelName}>Dmn Name</span>}>
                    <Input
                        data-test-id="bpmn_name"
                        defaultValue={editInitialData && editInitialData.dmnName}
                        onChange={e => { setFormName(e.target.value); setDisplayError({}) }}
                    />
                </Form.Item>
                <Form.Item label={<span className={style.labelName}>Description</span>}>
                    <Input
                        data-test-id="description"
                        defaultValue={editInitialData && editInitialData.description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </Form.Item>
            </Form>}
        </div>
    );
}

export default Dmn;
